import _property from 'lodash/property';

var addresses = _property('addresses');

var assignedCompany = _property('assignedCompany');

var discountPercentage = _property('discountPercentage');

var id = _property('id');

var paymentMethodDetails = _property('paymentMethodDetails');

var checkName = _property('paymentMethodDetails.checkName');

var electronicFundTransferDetail = _property('paymentMethodDetails.electronicFundTransferDetail');

var paymentTermId = _property('paymentTermId');

var pointOfContacts = _property('pointOfContacts');

var primary = _property('primary');

var siteName = _property('siteName');

var paymentMethod = _property('paymentMethod');

var preferredPaymentMethod = _property('preferredPaymentMethod');

var READER = {
  addresses: addresses,
  assignedCompany: assignedCompany,
  discountPercentage: discountPercentage,
  id: id,
  paymentMethodDetails: paymentMethodDetails,
  checkName: checkName,
  electronicFundTransferDetail: electronicFundTransferDetail,
  paymentTermId: paymentTermId,
  pointOfContacts: pointOfContacts,
  primary: primary,
  siteName: siteName,
  paymentMethod: paymentMethod,
  preferredPaymentMethod: preferredPaymentMethod
};
export default READER;